'use es6';

import { SHARE_URL_TYPE, SURVEY_URL_TYPE, getShareableUrl } from './ShareableUrlBuilder';
const VERSION = 1;
const LEGACY_UUID_IDENTIFIER = '-';
const BYTE_TO_HEX_MAP = [...Array(256)].map((v, i) => (i + 0x100).toString(16).substr(1));
const ENCODED_URL_PART_REGEX = /\/([a-z0-9-_]+)([?#].*|\/)?$/i;
const VALID_UUID_CHECK = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;
const BASE64_URL_SAFE_MAP = [['+', '-'], ['/', '_']];

function bytesToUuid(buf, offset) {
  let i = offset || 0;
  return [BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], '-', BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], '-', BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], '-', BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], '-', BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]]].join('');
}

function uuidToBytes(uuid) {
  // Assuming valid UUID
  const bytes = [];
  uuid.replace(/[a-fA-F0-9]{2}/g, hex => {
    bytes.push(parseInt(hex, 16));
  });
  return bytes;
}

function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  return window.btoa([...Array(bytes.byteLength)].reduce((t, v, i) => t + String.fromCharCode(bytes[i]), ''));
}

function base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64);
  return new Uint8Array([...Array(binaryString.length)].map((v, i) => binaryString.charCodeAt(i)));
}

function uuidToB64(uuid) {
  return arrayBufferToBase64(uuidToBytes(uuid));
}

function B64ToUuid(b64) {
  return bytesToUuid(base64ToArrayBuffer(b64));
}

function escapeBase64(b64) {
  return BASE64_URL_SAFE_MAP.reduce((t, v) => t.replace(new RegExp(`\\${v[0]}`, 'g'), v[1]), b64);
}

function unescapeBase64(b64) {
  return BASE64_URL_SAFE_MAP.reduce((t, v) => t.replace(new RegExp(`\\${v[1]}`, 'g'), v[0]), b64);
}

function isValidUuid(token) {
  return VALID_UUID_CHECK.test(token);
}

function getVersionFromSymbol(symbol) {
  return parseInt(symbol, 36) + (isNaN(symbol * 1) && symbol === symbol.toUpperCase() ? 26 : 0);
}

export function getCurrentVersionSymbol() {
  return VERSION < 36 ? VERSION.toString(36) : (VERSION - 26).toString(36).toUpperCase();
}
export function extractShareToken(shareableLink) {
  return ENCODED_URL_PART_REGEX.exec(shareableLink)[1];
}
export function decode(encodedString) {
  const legacyUuid = encodedString.charAt(0) === LEGACY_UUID_IDENTIFIER;
  const offset = legacyUuid ? 2 : 1;
  const formGuid = B64ToUuid(unescapeBase64(encodedString.substring(offset, 22 + offset)));
  return {
    formGuid: legacyUuid ? formGuid.replace(/-/g, '') : formGuid,
    portalId: parseInt(encodedString.substring(22 + offset), 36),
    version: getVersionFromSymbol(encodedString.charAt(offset - 1))
  };
}
export function decodeShareableLink(shareableLink) {
  return decode(extractShareToken(shareableLink));
}
export function encode(formGuid, portalId) {
  return `${isValidUuid(formGuid) ? '' : LEGACY_UUID_IDENTIFIER}${getCurrentVersionSymbol()}${escapeBase64(uuidToB64(formGuid.replace(/[^a-fA-F0-9]/g, '')).substring(0, 22))}${portalId.toString(36)}`;
}
export function getShareableLink(formGuid, portalId, isQA = false, hublet) {
  return `${getShareableUrl(SHARE_URL_TYPE, {
    hublet,
    isQA
  })}/${encode(formGuid, portalId)}`;
}
export function getSurveyLink(formGuid, portalId, isQA = false, hublet = '') {
  return `${getShareableUrl(SURVEY_URL_TYPE, {
    hublet,
    isQA
  })}/${encode(formGuid, portalId)}`;
}